const apiMethods = {
  methods: {
    parseHttpHeader(header) {
      let tempHeader = _g.updateHttpHeader()
      for (let key in tempHeader) {
        window.axios.defaults.headers[key] = tempHeader[key]
      }
    },
    apiGet(url, data) {
      this.parseHttpHeader()
      return new Promise((resolve, reject) => {
        axios.get(url, data).then((response) => {
          resolve(response.data)
        }, (response) => {
          let res = {
            code: response.status ? response.status : 500,
            error: '连接超时，请检查网络连接'
          }
          resolve(res)
          // reject(response)
          // alert('连接超时，请检查网络连接')
        })
      })
    },
    apiPost(url, data) {
      this.parseHttpHeader()
      return new Promise((resolve, reject) => {
        axios.post(url, data).then((response) => {
          resolve(response.data)
        }, (response) => {
          let res = {
            code: response.status ? response.status : 500,
            error: '连接超时，请检查网络连接'
          }
          resolve(res)
          // reject(response)
          // alert('连接超时，请检查网络连接')
        })
      })
    },
    apiDelete(url, id) {
      this.parseHttpHeader()
      return new Promise((resolve, reject) => {
        axios.delete(url + id).then((response) => {
          resolve(response.data)
        }, (response) => {
          let res = {
            code: response.status ? response.status : 500,
            error: '连接超时，请检查网络连接'
          }
          resolve(res)
          // reject(response)
          // alert('连接超时，请检查网络连接')
        })
      })
    },
    apiPut(url, id, obj) {
      this.parseHttpHeader()
      return new Promise((resolve, reject) => {
        axios.put(url + id, obj).then((response) => {
          resolve(response.data)
        }, (response) => {
          let res = {
            code: response.status ? response.status : 500,
            error: '连接超时，请检查网络连接'
          }
          resolve(res)
          // alert('连接超时，请检查网络连接')
          // reject(response)
        })
      })
    },
    promiseHandler(defaultVal, result) {
      this.parseHttpHeader()
      // console.log('promiseHandler result = ', result)
      if (result.code == 200) {
        defaultVal = result.data
      } else {
        _g.dealError(this, result)
      }
      return defaultVal
    }
  }
}

export default apiMethods



// WEBPACK FOOTER //
// ./src/assets/js/http.js